(() => {
  const article = document.querySelector('#evp-adv, #evp-adv2');
  if (!article || article.dataset.fortionClockReady) return;
  const elements = [...article.querySelectorAll('span')]
    .filter(label => label.textContent.trim() === 'HRS')
    .map(label => label.parentElement.parentElement);
  const clocks = [...new Set(elements)].map(element => ({
    element,
    digits: [...element.querySelectorAll(':scope > div > span:first-child')],
    labels: [...element.querySelectorAll(':scope > div > span:last-child')],
  })).filter(clock => clock.digits.length === 3
    && clock.labels.map(label => label.textContent.trim()).join(',') === 'HRS,MIN,SEC');
  if (!clocks.length) return;
  article.dataset.fortionClockReady = 'true';
  const cacheKey = 'fortion:home-countdown-config:v1';
  let config = {
    sectionId: 'sections--27845787156616__countdown',
    deadline: '2026-10-12T16:07:24.155Z',
    hours: 17,
    mode: 'recurring',
  };
  const valid = value => value && typeof value.sectionId === 'string'
    && Number.isFinite(Date.parse(value.deadline))
    && Number.isFinite(Number(value.hours)) && Number(value.hours) > 0
    && ['recurring', 'fixed'].includes(value.mode);
  try {
    const cached = JSON.parse(sessionStorage.getItem(cacheKey));
    if (valid(cached)) config = cached;
  } catch {}
  clocks.forEach(({element}) => {
    element.setAttribute('role', 'timer');
    element.setAttribute('aria-live', 'off');
    element.dataset.fortionSyncedClock = 'true';
  });
  const update = () => {
    const anchor = Date.parse(config.deadline);
    const duration = Number(config.hours) * 3600000;
    const now = Date.now();
    const elapsed = ((now - anchor) % duration + duration) % duration;
    const remaining = config.mode === 'recurring'
      ? Math.ceil((duration - elapsed) / 1000)
      : Math.max(0, Math.floor((anchor - now) / 1000));
    const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
    clocks.forEach(({digits}) => digits.forEach((digit, index) => {
      const value = String(values[index]).padStart(2, '0');
      if (digit.textContent !== value) digit.textContent = value;
    }));
  };
  const readConfig = html => {
    if (typeof html !== 'string') return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const bar = doc.querySelector('[data-vt-countdown]');
    if (!bar) return null;
    const wrapper = bar.closest('[id^="shopify-section-"]');
    const value = {
      sectionId: wrapper ? wrapper.id.replace('shopify-section-', '') : config.sectionId,
      deadline: bar.dataset.deadline,
      hours: Number(bar.dataset.hours),
      mode: bar.dataset.mode === 'recurring' ? 'recurring' : 'fixed',
    };
    return valid(value) ? value : null;
  };
  let request;
  const synchronize = () => {
    if (request) return request;
    request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const root = new URL(window.Shopify?.routes?.root || '/', location.origin);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) root.searchParams.set('preview_theme_id', preview);
        const url = new URL(root);
        url.searchParams.set('sections', config.sectionId);
        const response = await fetch(url, {signal: controller.signal});
        let latest;
        if (response.ok) {
          const sections = await response.json();
          latest = readConfig(sections[config.sectionId]);
        }
        if (!latest) {
          const home = await fetch(root, {signal: controller.signal});
          if (home.ok) latest = readConfig(await home.text());
        }
        if (latest) {
          config = latest;
          try { sessionStorage.setItem(cacheKey, JSON.stringify(config)); } catch {}
          article.dataset.fortionClockSource = 'home';
          update();
        }
      } catch {} finally { clearTimeout(timeout); }
    })().finally(() => { request = null; });
    return request;
  };
  update();
  setInterval(update, 1000);
  synchronize();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  window.addEventListener('pageshow', event => { update(); if (event.persisted) synchronize(); });
})();
